export function SecureIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="54" 
        height="56" 
        viewBox="0 0 54 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M28.4289 0.571509C28.0431 0.204547 27.5317 0 27 0C26.4683 0 25.9569 0.204547 25.5711 0.571509C19.6928 6.17189 11.8637 9.24297 3.75786 9.12815C3.31627 9.1224 2.88434 9.25801 2.52479 9.51529C2.16525 9.77257 1.89682 10.1381 1.75848 10.5589C0.58979 14.132 -0.00380843 17.8692 1.83852e-05 21.6297C1.83852e-05 38.1374 11.2542 52.0031 26.4822 55.9341C26.8218 56.022 27.1782 56.022 27.5179 55.9341C42.7458 52.0031 54 38.1374 54 21.6297C54 17.7681 53.3825 14.0454 52.2415 10.5589C52.1037 10.1376 51.8354 9.77145 51.4759 9.51363C51.1163 9.25582 50.6841 9.11981 50.2422 9.12538L49.8462 9.12815C41.5495 9.12815 34.0145 5.87774 28.4289 0.571509ZM36.9969 22.841C37.1631 22.6189 37.2833 22.3657 37.3505 22.0963C37.4177 21.8269 37.4306 21.5468 37.3884 21.2723C37.3461 20.9979 37.2496 20.7347 37.1045 20.4982C36.9594 20.2617 36.7687 20.0567 36.5435 19.8952C36.3183 19.7337 36.0632 19.6191 35.7932 19.5579C35.5232 19.4967 35.2437 19.4903 34.9712 19.5391C34.6987 19.5878 34.4386 19.6908 34.2063 19.8418C33.974 19.9928 33.7742 20.1889 33.6185 20.4185L24.6572 33.0034L20.16 28.4917C19.7663 28.1237 19.2456 27.9233 18.7075 27.9328C18.1694 27.9424 17.656 28.161 17.2755 28.5428C16.895 28.9245 16.677 29.4396 16.6675 29.9794C16.658 30.5191 16.8578 31.0416 17.2246 31.4365L23.4554 37.6873C23.6686 37.9011 23.9256 38.0657 24.2086 38.1698C24.4916 38.2738 24.7937 38.3149 25.0941 38.29C25.3945 38.2652 25.6859 38.175 25.9481 38.0259C26.2102 37.8767 26.4369 37.6721 26.6123 37.4262L36.9969 22.841Z" 
          fill="url(#paint0_linear_secure)" 
        />
        <defs>
          <linearGradient 
            id="paint0_linear_secure" 
            x1="27" 
            y1="56" 
            x2="27" 
            y2="-3" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#56AB2F"/>
            <stop offset="1" stopColor="#A8E063"/>
          </linearGradient>
        </defs>
      </svg>
    )
  }